import { render, staticRenderFns } from "./AddonBuyerReso.vue?vue&type=template&id=b0aeba9e&scoped=true&"
var script = {}
import style0 from "./AddonBuyerReso.vue?vue&type=style&index=0&id=b0aeba9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0aeba9e",
  null
  
)

export default component.exports